import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import GoldDivider from '../components/GoldDivider';

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '2.5rem' }}>
      <h2
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: '1.5rem',
          color: 'var(--gold-light)',
          marginBottom: '1rem',
        }}
      >
        {title}
      </h2>
      {children}
    </div>
  );
}

function BulletItem({ children }) {
  return (
    <li
      style={{
        color: 'var(--cream)',
        marginBottom: '0.4rem',
        lineHeight: 1.6,
        listStyle: 'none',
        paddingLeft: '1.2rem',
        position: 'relative',
      }}
    >
      <span
        style={{
          position: 'absolute',
          left: 0,
          color: 'var(--gold)',
        }}
      >
        ✦
      </span>
      {children}
    </li>
  );
}

export default function Erlangen() {
  const { t } = useLanguage();
  const e = t('erlangen');

  return (
    <div className="page-container" style={{ paddingTop: '2rem' }}>
      {/* Header */}
      <p
        style={{
          fontFamily: "'Cinzel', serif",
          fontSize: '0.65rem',
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          color: 'var(--gold)',
          textAlign: 'center',
          marginBottom: '0.5rem',
        }}
      >
        {e.tag}
      </p>
      <h1 className="page-title">{e.title}</h1>
      <GoldDivider />

      <div className="card" style={{ maxWidth: '800px', margin: '0 auto' }}>

        {/* Shopping */}
        <Section title={e.shopping_title}>
          <p style={{ color: 'var(--cream)', lineHeight: 1.7, marginBottom: '1rem' }}>
            {e.shopping_intro}
          </p>
          <p style={{ color: 'rgba(245,233,198,0.7)', fontSize: '0.9rem', marginBottom: '0.75rem' }}>
            {e.shopping_addresses}
          </p>
          <ul style={{ padding: 0, margin: '0 0 1rem 0' }}>
            <BulletItem>{e.shopping_adidas}</BulletItem>
            <BulletItem>{e.shopping_puma}</BulletItem>
            <BulletItem>{e.shopping_others}</BulletItem>
          </ul>
          <p
            style={{
              color: 'rgba(245,233,198,0.6)',
              fontSize: '0.875rem',
              fontStyle: 'italic',
              lineHeight: 1.6,
              borderLeft: '2px solid rgba(201,168,76,0.4)',
              paddingLeft: '0.75rem',
            }}
          >
            {e.shopping_note}
          </p>
        </Section>

        <GoldDivider />

        {/* Culture */}
        <Section title={e.culture_title}>
          <p style={{ color: 'var(--cream)', lineHeight: 1.7, marginBottom: '1.25rem' }}>
            {e.culture_intro}
          </p>
          <p
            style={{
              fontFamily: "'Cinzel', serif",
              fontSize: '0.7rem',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: 'var(--gold)',
              marginBottom: '1rem',
            }}
          >
            {e.culture_subtitle}
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {e.biergaerten.map((bg) => (
              <div
                key={bg.name}
                style={{
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(201,168,76,0.2)',
                  borderRadius: '4px',
                  padding: '1rem 1.25rem',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.75rem', marginBottom: '0.4rem', flexWrap: 'wrap' }}>
                  <strong
                    style={{
                      fontFamily: "'Cormorant Garamond', serif",
                      fontSize: '1.05rem',
                      color: 'var(--gold-light)',
                    }}
                  >
                    {bg.name}
                  </strong>
                  {bg.url && (
                    <a
                      href={bg.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ fontSize: '0.8rem', color: 'var(--gold)', opacity: 0.8 }}
                    >
                      ↗ Website
                    </a>
                  )}
                </div>
                <p style={{ color: 'rgba(245,233,198,0.75)', fontSize: '0.9rem', lineHeight: 1.6, margin: 0 }}>
                  {bg.desc}
                </p>
              </div>
            ))}
          </div>
        </Section>

        <GoldDivider />

        {/* Siemens */}
        <Section title={e.siemens_title}>
          <p style={{ color: 'var(--cream)', lineHeight: 1.7 }}>
            {e.siemens_text}
          </p>
        </Section>

        <GoldDivider />

        {/* Vacation */}
        <Section title={e.vacation_title}>
          <p style={{ color: 'var(--cream)', lineHeight: 1.7 }}>
            {e.vacation_text}
          </p>
        </Section>

      </div>
    </div>
  );
}
